<template>
  <div>
    <!-- swiper1 -->
    <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
      <swiper-slide v-for="(item,index) in shopimg" :key="index">
        <router-link :to="{path:'/huodongdetails', query:{ goods_id:item.goods_id,panic_id:item.panic_id,type:2}}">
          <img :src="http + item.image" alt="" class="v_img1">
        </router-link>
      </swiper-slide>
    </swiper>
    <!-- swiper2 Thumbs -->
    <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
      <swiper-slide v-for="(item,index) in shopimg" :key="index" >
        <img :src="http + item.image" alt="" class="v_img2" @click="skusIndexFn(index,item.id,firstindex)">
      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
    export default {
        props: {
            shopimg: {
              // type: Array,
              default () {
                return [];
              }
            },
          firstindex:{
            default () {
              return '';
            }
          }
        },
        data() {
            return {
                swiperOptionTop: {
                    spaceBetween: 10,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },

                },
                swiperOptionThumbs: {
                    spaceBetween: 10,
                    centeredSlides: true,
                    slidesPerView: 'auto',
                    slideToClickedSlide: true,
                    observer: true,
                    observeParents: true,

                },
              http:'',//域名拼接

            }
        },
      created() {
        let that = this;

        that.http = that.$publicUrl.http1;

      },
        mounted() {
            this.$nextTick(() => {
              // console.log(this.$refs)
                const swiperTop = this.$refs.swiperTop.swiper
                const swiperThumbs = this.$refs.swiperThumbs.swiper
                swiperTop.controller.control = swiperThumbs
                swiperThumbs.controller.control = swiperTop
              // console.log(swiperThumbs)
            })
        },
      methods:{
        skusIndexFn(index,shopid,firstindex){

          // console.log(index)
          this.$emit('skusindexfn', {index:index,shopid:shopid,firstindex:firstindex})
        }
      }
    }
</script>
<style scoped>
    .swiper-container {
        background-color: #000;
    }

    .swiper-slide {
        background-size: cover;
        background-position: center;
    }

    .gallery-top {
        height: 80% !important;
        width: 100%;
    }

    .gallery-thumbs {
        height: 20% !important;
        box-sizing: border-box;
        padding: 10px 0;
    }

    .gallery-thumbs .swiper-slide {
        width: 25%;
        height: 100%;
        opacity: 0.4;
    }

    .gallery-thumbs .swiper-slide-active {
        opacity: 1;
    }

    .v_img1 {
        width: 100%;
        height: 220px;
        display: block;
        object-fit: scale-down;
    }

    .v_img2 {
        width: 23px;
        height: 23px;
        display: block;
        object-fit: scale-down;
    }

    .swiper-container {
        background-color: #ffffff;
    }

    .gallery-thumbs .swiper-slide {
        width: 25px !important;
        height: 25px !important;
        border: 1px solid #dddddd;
    }

    .gallery-thumbs .swiper-slide-active {
        border: 1px solid red;
    }

    .boxcenter {
        width: 100%;
        height: 50px;
        line-height: 25px;
        font-size: 14px;
        padding: 0 10px;
        box-sizing: border-box;
    }

    .boxbtn {
        width: 100%;
        height: 30px;
        padding: 0 10px;
        box-sizing: border-box;
    }

    .boxbtnleft {
        flex: 1;
        height: 30px;
        font-size: 22px;
        color: #dc1e33;
    }

    .boxbtnleft span {
        display: inline-block;
        font-size: 16px;
        height: 30px;
        line-height: 30px;
    }

    .boxbtnright img {
        display: inline-block;
        height: 30px;
        width: 30px;
        object-fit: scale-down;
        margin-right: 5px;
    }

    .boxbtnright span {
        display: inline-block;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
    }

    .gallery-thumbs {
        width: 80%;
    }
</style>
